(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssups-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ssupsHomeHeroVideoMotionSync) return;

    window.ssupsHomeHeroVideoMotionSync = true;

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncHeroVideos = () => {
      document.querySelectorAll('.ssups-home-hero__video').forEach((video) => {
        if (motionQuery.matches) {
          video.pause();
          video.removeAttribute('autoplay');
          return;
        }

        if (video.dataset.ssupsAutoplay === 'true') {
          video.setAttribute('autoplay', '');
        }
      });
    };

    syncHeroVideos();
    document.addEventListener('shopify:section:load', syncHeroVideos);

    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', syncHeroVideos);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssups-product-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const summary = event.target.closest('.ssups-product-details__summary-button');
    if (!summary) return;

    const item = summary.closest('.ssups-product-details__item');
    if (!item) return;

    event.preventDefault();
    item.open = !item.open;
  });

  } catch(e) { console.error(e); }
})();
})();
